/* tslint:disable:no-console */

/**
 * THIS FILE IS DEPRECATED, DO NOT USE IT
 */

/**
 * @deprecated look at translator-next.ts
 */
export function getLocale(cb?: (locale?: Locale) => void): void | string {
  let locale: Locale;

  if (typeof window === 'undefined') {
    if (cb) {
      cb();
    }

    return '';
  }

  if (window.navigator && window.navigator.language) {
    locale = window.navigator.language.split('-')[0] as Locale;
  } else {
    locale = 'en';
  }

  if (!cb) {
    return locale;
  }

  return cb(locale);
}

/**
 * @deprecated look at translator-next.ts
 */
export function navigateObject(path: string, object: object = {}) {
  try {
    return path.split('.').reduce((o: AnyObject, i) => o[i], object);
  } catch (err) {
    console.error(err);
    return path;
  }
}

/**
 * @deprecated look at translator-next.ts
 */
export function replaceArgs(str: string = '', args: AnyObject): string {
  if (!args) {
    return str;
  }

  return Object.keys(args).reduce((acc, arg) => {
    return acc.replace(new RegExp(`#{${arg}}`, 'g'), args[arg]);
  }, str);
}

/**
 * @deprecated look at translator-next.ts
 */
export function createTranslator(
  lang: Locale,
  defaultTranslations: any = {},
  customTranslations: any = {}
): any {
  let translations: any;
  if (defaultTranslations[lang]) {
    translations = { ...defaultTranslations[lang] };
  } else {
    translations = { ...defaultTranslations.en };
  }

  // Override with custom translations
  if (customTranslations[lang]) {
    Object.keys(customTranslations[lang]).forEach(globalKey => {
      if (typeof customTranslations[lang][globalKey] === 'object') {
        Object.keys(customTranslations[lang][globalKey]).forEach(labelKey => {
          // create entries to avoid unknown key error
          translations[globalKey] = translations[globalKey] || {};

          translations[globalKey][labelKey] =
            customTranslations[lang][globalKey][labelKey];
        });
      } else {
        translations[globalKey] = customTranslations[lang][globalKey];
      }
    });
  }

  return (path: string, args: object) => {
    const str = navigateObject(path, translations);

    if (str && typeof str === 'string') {
      return replaceArgs(str, args);
    } else {
      return '';
    }
  };
}
